import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { getSafe, isNilOrEmpty } from 'helpers';

export interface CampaignFileDialogData {
  campaignId: string;
}

@Component({
  selector: 'app-campaign-file.dialog',
  templateUrl: './campaign-file.dialog.html',
})
export class CampaignFileDialog
  extends WithDisposableSubject() {
  static open(
    dialog: MatDialog,
    config: MatDialogConfig<CampaignFileDialogData>
  ) {
    return dialog.open(CampaignFileDialog, config);
  }

  uploadItem: null;

  get file() {
    return null;
    // return getSafe(() => this.uploadItem.getFile(), null);
  }

  constructor(
    public dialogRef: MatDialogRef<CampaignFileDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignFileDialogData
  ) {
    super();
  }


  fileSelected(file: File) {}

  onSave() {
    close();
  }

  close(result?: any) {
    this.dialogRef.close(result);
  }
}
